"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validationResultFragment = void 0;
exports.validationResultFragment = `
  fragment validationResult on ApplicationValidationResult {
    isValid
    validationMessage
  }
`;
//# sourceMappingURL=application.js.map